export default "__VITE_ASSET__eM1UWtok__"